export class ResponseDatosActa{
    payload:DatosActa;

    constructor(){
        this.payload = new DatosActa();
    }
}

export class DatosActa{    

    idActaTutoria:number;
    idJardinPeriodoTutoria:number;
    numeroParticipantes:number;
    fechaInicio:Date;
    fechaFin:Date;
    comentarioTutor:string; 
    comentarioJardin:string; 
    estadoActa:string;
    idEstadoActa:number;
    participantes:Participantes[];
    constructor(){
        this.idActaTutoria = 0;
        this.idJardinPeriodoTutoria = 0;
        this.numeroParticipantes = 0;
        this.fechaInicio = null;
        this.fechaFin = null;
        this.comentarioTutor = "";
        this.comentarioJardin = "";
        this.estadoActa = "";
        this.idEstadoActa = 0;
        this.participantes = new Array<Participantes>();
    }
}



export class Participantes{    
    id:number;
    participante:string;
    rol:string;
    constructor(){
        this.id=0;
        this.participante = "";
        this.rol = "";

    }
}

